import { UserOutlined } from '@ant-design/icons';
import { Avatar, AvatarProps } from 'antd';
import React from 'react';

export const AvatarUser: React.FC<AvatarProps> = ({ size, src: logo }) => {
	return <Avatar size={size ?? 'large'} icon={<UserOutlined />} src={logo} />;
};
